// Export configuration values for use across the application
import config from "./config/index";

// API URL for REST endpoints
export const API_URL = config.api.url;

// WebSocket URL for real-time connections
export const WS_URL = config.ws.url;

// Export any other configuration values that might be needed
export default config;
